// extracted by mini-css-extract-plugin
module.exports = {"link":"_2ho6G","ShinyGradientButton":"_1thu9","shinyGradientButton":"_1thu9","label":"_2S3PR","mainColor":"WVk2K","pose":"_1lEYC","topper":"-slS9","oval":"_1uCNt","bord":"_3OYMc"};